export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/forest-bg-593af7c54a2ac820627048e8d39fb083.jpg";